@if (safeUrl()) {
	<div class="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
		<img
			[src]="safeUrl()"
			[alt]="caption() || 'Imagen'"
			class="w-full max-h-80 object-contain cursor-pointer hover:opacity-90 transition-opacity"
			loading="lazy"
			(click)="enlarge.set(true)"
		/>
		@if (caption()) {
			<div class="px-3 py-2 border-t border-slate-100">
				<p class="text-sm text-slate-600">{{ caption() }}</p>
			</div>
		}
	</div>
} @else {
	<div class="flex items-center gap-2 rounded-lg bg-slate-100 px-4 py-3 border border-slate-200">
		<i class="bi bi-image text-slate-400 text-lg"></i>
		<span class="text-sm text-slate-500">Imagen no disponible</span>
	</div>
}

@if (enlarge()) {
	<div
		class="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm"
		(click)="enlarge.set(false)"
	>
		<button
			class="absolute top-4 right-4 text-white text-2xl hover:opacity-70 transition-opacity z-50"
			(click)="enlarge.set(false)"
		>
			<i class="bi bi-x-lg"></i>
		</button>
		<img
			[src]="safeUrl()"
			[alt]="caption() || 'Imagen'"
			class="max-h-[90vh] max-w-[90vw] object-contain rounded-lg shadow-2xl"
			(click)="$event.stopPropagation()"
		/>
		@if (caption()) {
			<div class="absolute bottom-6 left-1/2 -translate-x-1/2 rounded-lg bg-black/60 px-4 py-2">
				<p class="text-sm text-white">{{ caption() }}</p>
			</div>
		}
	</div>
}
